import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function proCreateOrUpdatePatientConsent(
  patientUserId: string,
  aiPolicyConsented: boolean,
  orchidPolicyConsented: boolean,
) {
  const res = await fetchOrchidAPI(
    `/api/users/v1/orchid_pro/patient_consent/patient/${patientUserId}`,
    {
      method: "POST",
      body: JSON.stringify({
        ai_policy_consented: aiPolicyConsented,
        orchid_policy_consented: orchidPolicyConsented,
      }),
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    console.error(getErrorDetail(responseText));
  }
  return res;
}
